import BrandArrow from "@/components/BrandArrow";

/* ═══════════════════════════════════════════════════════════════
   Единая стрелка листания для всех слайдеров сайта (кейсы, исследования,
   медиа). Выносится ЗА пределы карточек (в боковые поля). Обычное состояние —
   с обводкой (белый фон + рамка, приглушённый шеврон); на ховере заливается
   акцентом (оранжевый фон, белый шеврон). Позиционирование и адаптив задаёт
   родитель через className; `disabled` прячет стрелку у края (opacity-0).
   ═══════════════════════════════════════════════════════════════ */

type Props = {
  dir: "left" | "right";
  onClick: () => void;
  disabled?: boolean;
  className?: string;
};

const SliderArrow = ({ dir, onClick, disabled = false, className = "" }: Props) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={dir === "left" ? "Назад" : "Вперёд"}
    className={`w-11 h-11 rounded-full bg-background border border-border shadow-sm flex items-center justify-center text-foreground/70 transition-all duration-200 hover:bg-accent hover:border-accent hover:text-white hover:shadow-md ${
      disabled ? "opacity-0 pointer-events-none" : "opacity-100"
    } ${className}`}
  >
    <BrandArrow className={`h-[18px] w-[18px] ${dir === "left" ? "rotate-180" : ""}`} />
  </button>
);

export default SliderArrow;
